export const DELAY_OPTION = [
  { name: '0 s', value: 0 },
  { name: '1 s', value: 1 },
  { name: '2 s', value: 2 },
  { name: '3 s', value: 3 },
  { name: '4 s', value: 4 },
  { name: '5 s', value: 5 },
  { name: '6 s', value: 6 },
  { name: '7 s', value: 7 },
  { name: '8 s', value: 8 },
  { name: '9 s', value: 9 },
  { name: '10 s', value: 10 }
];

export const DEFAULT_FRAME_DELAY = 3;

export const MAX_PLAYBACK_DELAY = 3600; // seconds
